// src/pages/DevLogPost.jsx

import { useParams, Link } from "react-router-dom";
import { devLogs } from "../data/devLogs";

function DevLogPost() {
  const { id } = useParams();

  const post = devLogs.find((entry) => entry.id === id);

  if (!post) {
    return (
      <main className="dev-log-page">
        <section className="text-area">
          <h1>Post Not Found</h1>
          <Link className="page-button" to="/dev-log">
            Back to Dev Log
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="dev-log-page">
      <section className="text-area">
        <p className="dev-log-date">{post.date}</p>
        <h1>{post.title}</h1>

        <div className="dev-log-content">
          {post.content.split("\n").map((paragraph, index) =>
            paragraph.trim() === "" ? null : <p key={index}>{paragraph}</p>
          )}
        </div>

        <Link className="page-button" to="/devlog">
          Back to Dev Log
        </Link>
      </section>
    </main>
  );
}

export default DevLogPost;